import React from "react";
import Header from "./Header";

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <div className={"flex grow flex-col"}>
        <Header />
      </div>
      <div className={"flex h-screen flex-grow flex-row"}>{children}</div>
    </>
  );
}
